// Module-scoped (survives Canvas.jsx mount/unmount within the same page
// load, unlike component state) queue of "this project needs a forced
// vfs-service -> IndexedDB resync" requests.
//
// Why this exists: VfsChatPanel.jsx (always mounted while chatting) learns
// the moment vfs_get_preview_url succeeds — exactly when a forced resync
// should happen (see Canvas.jsx's forceResyncServiceFromVfs). But Canvas.jsx
// itself is NOT mounted at all while on the plain chat door (hideCanvas) —
// it only mounts once the user switches to Code — so a plain
// window.dispatchEvent('vfsForceResync') fired during that common case
// (agent finishes a build while still in Chat) has no listener yet and is
// lost. Canvas.jsx drains this queue on mount (in addition to still
// listening live for the event, for the case where it's already mounted)
// so the resync isn't dropped either way.
const pending = new Map(); // projectId -> true

export function addPendingVfsResync(projectId) {
  if (!projectId) return;
  pending.set(projectId, true);
}

export function drainPendingVfsResync(projectId) {
  if (!projectId || !pending.has(projectId)) return false;
  pending.delete(projectId);
  return true;
}
